import { Module } from 'vuex';
import { GroupsManagerStorable } from '@/shared/config/store/groups-manager-store';

export interface InsightStore {
  reportList: Array<any>;
  isBackFromDetail: boolean;
}

export const insightStore: Module<InsightStore, any> = {
  namespaced: true,
  state: {
    reportList: [],
    isBackFromDetail: false,
  },
  getters: {
    getReportList: state => state.reportList,
    getIsBackFromDetail: state => state.isBackFromDetail,
  },
  mutations: {
    setReportList(state, reportList) {
      state.reportList = reportList;
    },
    setIsBackFromDetail(state, isBackFromDetail) {
      state.isBackFromDetail = isBackFromDetail;
    },
  },
  actions: {
    setIsBackFromDetail(context, payload: { newVal: any }) {
      context.commit('setIsBackFromDetail', payload.newVal);
    },
  },
};
